import 'angular-ui-tree';
import 'ng-sortable';

import eventRoutes from './event.routes';

import categorySaveController from './controllers/category.save.controller';
import optionsSaveController from './controllers/options.save.controller';
import categoryFormController from './controllers/category.form.controller';
import categoryListController from './controllers/category.list.controller';
import optionsListController from './controllers/options.list.controller';
import categoriesSelectController from './controllers/categories.select.controller';
import categorySelectController from './controllers/category.select.controller';
import relatedFormController from './controllers/related.form.controller';
import crossFormController from './controllers/cross.form.controller';
import extrasListController from './controllers/extras.list.controller';
import extrasSaveController from './controllers/extras.save.controller';
import extrasFormController from './controllers/extras.form.controller';
import startTimesController from './controllers/start.times.controller';
import eventMultiSelectFormController from './controllers/event.multiSelect.form.controller';
import optionsFormController from './controllers/options.form.controller';
import upgradesListController from './controllers/upgrades.list.controller';

import categoryListComponent from './components/category.list.component';
import optionsListComponent from './components/options.list.component';
import categoryFormComponent from './components/category.form.component';
import categorySaveComponent from './components/category.save.component';
import optionsSaveComponent from './components/options.save.component';
import categoriesSelectComponent from './components/categories.select.component';
import categorySelectComponent from './components/category.select.component';
import relatedFormComponent from './components/related.form.component';
import crossFormComponent from './components/cross.form.component';
import startTimesComponent from './components/start.times.component';
import extrasListComponent from './components/extras.list.component';
import extrasSaveComponent from './components/extras.save.component';
import extrasFormComponent from './components/extras.form.component';
import eventMultiSelectFormComponent from './components/event.multiSelect.form.component';
import optionsFormComponent from './components/options.form.component';
import upgradesListComponent from './components/upgrades.list.component';

import categoriesService from './services/categories.service';
import eventsService from './services/events.service';
import extrasService from './services/extras.service';
import optionsService from './services/options.service';
import categoryAssignService from './services/category.assignment.service';
import categoriesTranformerService from './services/categories.transformer.service';

let eventModule = angular.module('spabooker.event', ['spabooker.base', 'ui.tree', 'as.sortable'])
    .config(eventRoutes)

    .controller('categorySaveController', categorySaveController)
    .controller('optionsSaveController', optionsSaveController)
    .controller('categoryFormController', categoryFormController)
    .controller('categoryListController', categoryListController)
    .controller('optionsListController', optionsListController)
    .controller('categoriesSelectController', categoriesSelectController)
    .controller('categorySelectController', categorySelectController)
    .controller('relatedFormController', relatedFormController)
    .controller('crossFormController', crossFormController)
    .controller('extrasListController', extrasListController)
    .controller('extrasSaveController', extrasSaveController)
    .controller('extrasFormController', extrasFormController)
    .controller('startTimesController', startTimesController)
    .controller('eventMultiSelectFormController', eventMultiSelectFormController)
    .controller('optionsFormController', optionsFormController)
    .controller('upgradesListController', upgradesListController)

    .component('categoryList', categoryListComponent)
    .component('optionsList', optionsListComponent)
    .component('categoryForm', categoryFormComponent)
    .component('categorySave', categorySaveComponent)
    .component('optionsSave', optionsSaveComponent)
    .component('categoriesSelect', categoriesSelectComponent)
    .component('categorySelect', categorySelectComponent)
    .component('relatedForm', relatedFormComponent)
    .component('crossForm', crossFormComponent)
    .component('extrasList', extrasListComponent)
    .component('extrasSave', extrasSaveComponent)
    .component('extrasForm', extrasFormComponent)
    .component('eventMultiSelectForm', eventMultiSelectFormComponent)
    .component('optionsForm', optionsFormComponent)
    .component('startTimes', startTimesComponent)
    .component('upgradesList', upgradesListComponent)

    .factory('categoriesService', categoriesService)
    .factory('eventsService', eventsService)
    .factory('extrasService', extrasService)
    .factory('optionsService', optionsService)
    .factory('categoriesTransformer', categoriesTranformerService)
    .factory('categoryAssignService', categoryAssignService)
    ;

export default eventModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/index.js